import {UserService} from '../../../services/user.service';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Component, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material';
import {RuleDialog} from '../../price-rules/rule-dialog/rule-dialog.component';
import {PricingRulesService} from '../../../services/pricing-rules.service';
import {DialogSharedComponent} from '../../dialog-shared/dialog-shared.component';

@Component({
  selector: 'user-dialog',
  templateUrl: './user-dialog.component.html'
})
export class UserDialog implements OnInit {
  userDetail = 'detail';
  userDetails: any;
  userDetailsForm: FormGroup;
  userDiscountsForm: FormGroup;
  allExtraCharges = [];
  companies = [{name: 'N/A', id: null}];
  progress = false;
  customerRules: any;
  customer: any;
  openWindow(href) {
    window.open(href, '');
    return false;
  }
  constructor(private userService: UserService,
              private _fb: FormBuilder,
              public dialog: MatDialog,
              private pricingRulesService: PricingRulesService,
              public dialogRef: MatDialogRef<UserDialog>) { }

  ngOnInit() {
    this.userDetailsForm = this._fb.group({
      user: this._fb.group({
        name: [this.userDetails.name, Validators.required],
        surname: [this.userDetails.surname, Validators.required],
        email: [this.userDetails.email, Validators.required],
        // company_name: [this.userDetails.company_name],
        company_name: new FormControl(this.userDetails.company_name),
        phone: [this.userDetails.phone],
        invoice_country_code: [this.userDetails.invoice_country_code],
        invoice_zip: [this.userDetails.invoice_zip],
        invoice_city: [this.userDetails.invoice_city],
        invoice_address: [this.userDetails.invoice_address],
        confirmed: [this.userDetails.confirmed],
        role: [this.userDetails.role],
        status: [this.userDetails.status],
        master_id: [this.userDetails.master_id],
        logged_at: [this.userDetails.logged_at],
        id: [this.userDetails.id]
      }),
    });
    this.userDiscountsForm = this._fb.group({
      user: this._fb.group({
        discount: this._fb.array([
          ['']
        ])
      }),
    });
    const params =  {page : 1,
      size: '100',
      filter: '',
      sort: '',
      order: ''};

    this.userService.getCompanies(params).subscribe((companies) => {
      for (const i in companies.data) {
        this.companies.push(companies.data[i]);
      }
    });
    this.userService.getDiscount().subscribe((discount) => {
      for (const j in discount.general) {
        (<FormArray>this.userDiscountsForm.controls['user']['controls'].discount).push(new FormControl(discount.general[j]));
      }
    });

    this.pricingRulesService.getCustomerRules(this.customer).subscribe((data) => {
      if (data.customer) { this.customerRules = data.customer; } else { this.customerRules = []; }
    }, (err) => {
      console.log(err);
    });

    this.customer = this.userDetails.id;
  }

  changeCompany(companyId) {
    this.progress = true;
    if (companyId.value == null) {
      this.userService.unassignUser(companyId.value, this.userDetails.id).subscribe(() => {
        this.progress = false;
      });
    } else {
      this.userService.assignUser(companyId.value, this.userDetails.id).subscribe(() => {
        this.progress = false;
      });
    }

  }

  toggleDetail(selector) {
    this.userDetail = selector;
  }

  save() {
    this.progress = true;
    if (this.userDetailsForm.valid) {
      const controls = this.userDetailsForm.controls['user'];
      const data = {
        id:   controls['controls'].id.value,
        name:   controls['controls'].name.value,
        surname:   controls['controls'].surname.value,
        email:   controls['controls'].email.value,
        phone:   controls['controls'].phone.value,
        country:   controls['controls'].country.value,
        zip:   controls['controls'].zip.value,
        city:   controls['controls'].city.value,
        address:   controls['controls'].address.value,
        confirmed:   controls['controls'].confirmed.value,
        role:   controls['controls'].role.value,
        status:   controls['controls'].status.value,
        master_id:   controls['controls'].master_id.value,
        logged_at:   controls['controls'].logged_at.value,
      };

      this.userService.setUser(data).subscribe(() => {
        this.progress = false;
        this.dialogRef.close('Yes!');
      });
    } else {
      const dialogRef = this.dialog.open(DialogSharedComponent,
        {width: '450px', data: { errorType: 'null', header: 'service.fieldsMustBeFilled' }});
    }
    return false;
  }

  openRuleDialog(type: string, pid: string, item: any = '') {
    const dialogRef = this.dialog.open(RuleDialog, {width: '600px'});
    dialogRef.afterClosed().subscribe(result => {
        this.pricingRulesService.getCustomerRules(this.customer).subscribe((data) => {
          if (data.customer) { this.customerRules = data.customer; } else { this.customerRules = []; }
        }, (err) => {
          console.log(err);
        });
    });

    const params = {
      type: type,
      pid: pid,
      item: item
    };
    // let rules = {
    //   ruleActions: this.ruleActions,
    //   ruleTypes: this.ruleTypes
    // };
    // let cond = {
    //   condLogic: this.condLogic,
    //   condCompare: this.condCompare,
    //   condProp: this.condProp,
    //   condPropVal: this.condPropVal
    // };
    dialogRef.componentInstance.rule = params;
    // dialogRef.componentInstance.rules = rules;
    // dialogRef.componentInstance.cond = cond;
  }

  transferDataSuccess(arr: any, item: any, pos: any) {
    this.changeOrder(arr);
  }
  changeOrder(items: any) {
    const sort = {
      'objects': []
    };
    for (const i in items) {
      items[i]['order'] = i;
      sort['objects'].push({
        'id': items[i]['id'],
        'order': items[i]['order']
      });
    }
    this.pricingRulesService.sortPricingRules(sort).subscribe((data) => {
    }, (err) => {
      console.log(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/user-dialog/user-dialog.component.ts